module.exports = __webpack_public_path__ + "img/bg.d2c095c7.jpg";